const physicalEntityForm = {
  /**
   * Client form key
   * @type {String}
   */
  key: "physicalEntityForm",

  /**
   * Client form fields object
   * @type {Object}
   */
  fields: {
    firstName: "",
    lastName: "",
    personalIdentityNumber: "",
    phone: "",
    email: "",
    city: "",
    address: "",
    zipCode: "",
    note: "",
    bookingNotificationsEnabled: false,
    marketingNotificationsEnabled: false,
  },

  /**
   * Client form helpers object
   * @type {Object}
   */
  helpers: {},

  /**
   * Client form errors object
   * @type {Object}
   */
  errors: {},

  /**
   * Client form mode
   * @type {String}
   */
  mode: "create",

  /**
   * Client form path
   * @type {String}
   */
  path: "/api/b2b/physical-entities",
};

export default physicalEntityForm;
